// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__Pj7Ax","wrapper":"modal_wrapper__KCS+s"};